import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndPoint = apiUrl + "api/language/";

export function getAllLanguage() {
  return http.get(apiEndPoint + "getAllLanguages");
}

export function setLanguage(data) {
  http.setLanguage(data.id);
  localStorage.setItem("CokeAdminLanguagePath", data.directory);
  localStorage.setItem("CokeAdminLanguageName", data.name);
  localStorage.setItem("CokeAdminLanguageId", data.id);  
  window.location.reload();
}

export function getLanguageData(path) {
  return http.get(apiEndPoint + "getLanguageByCode/" + path);
}
